import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function AlertSettings() {
  const [threshold, setThreshold] = useState(3);
  const [saved, setSaved] = useState(3);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => { setThreshold(r.data.absence_threshold); setSaved(r.data.absence_threshold); }).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/admin/settings", { absence_threshold: Number(threshold) });
      setSaved(data.absence_threshold);
      toast.success(`Absence alerts now trigger after ${data.absence_threshold} missed meetings in a row`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <Card className="card-shadow-soft" data-testid="alert-settings">
      <CardHeader><CardTitle className="text-lg">Absence alert threshold</CardTitle></CardHeader>
      <CardContent>
        <form onSubmit={save} className="flex flex-col sm:flex-row sm:items-end gap-3">
          <div className="space-y-1.5">
            <Label>Missed meetings in a row before a scout is flagged</Label>
            <Input type="number" min={1} max={20} data-testid="threshold-input" value={threshold} onChange={(e) => setThreshold(e.target.value)} className="min-h-[44px] w-32" />
          </div>
          <Button type="submit" disabled={busy || Number(threshold) === saved} data-testid="threshold-save" className="min-h-[44px]">Save</Button>
          <span className="text-xs text-muted-foreground" data-testid="threshold-current">Currently: {saved}</span>
        </form>
      </CardContent>
    </Card>
  );
}
